import React from 'react';
import PasswordWrapper from 'modules/blocks/inputs/PasswordWrapper';
import _ from 'lodash';
import validate from 'validate.js';
import {NEW_PASSWORD} from 'constants/usersConstrains';
import {withRouter} from 'react-router-dom';
import HttpClient from 'services/HttpClient';
import {inject} from 'mobx-react';

const RECOVERY_TOKEN_CREATE = '/api/v1/passwords_recovery';

@withRouter
@inject('alertStore')
export default class ResetFormPassword extends React.Component {

  state = {
    errors  : {},
    formData: {
      password             : '',
      password_confirmation: ''
    }
  };

  handleChange = e => {
    let newState = _.assign({}, this.state.formData, {[e.target.name]: e.target.value});
    this.setState({formData: newState});
  };

  handleSubmit = e => {
    e.preventDefault();
    let errors = validate(this.state.formData, NEW_PASSWORD, {fullMessages: false});
    this.setState({errors: errors || {}});
    if (!errors) {
      const requestBody = _.assign({}, this.state.formData, {token: this.props.match.params.token});
      new HttpClient().put(RECOVERY_TOKEN_CREATE, requestBody).then(() => {
        this.handleResponse();
      }).catch(() => {
        this.handleResponse();
      });
    }
  };

  handleResponse = () => {
    this.props.alertStore.success('Your password has been reset successfully. Please log in to continue.');
    this.props.history.push('/signIn');
  };

  render() {
    return (
      <div className="form-wrapper">
        <div className="form-container ">
          <div className="form-header-wrap">
            <div className="subtitle">Reset Your Password</div>
          </div>
          <div className="form-content col-4">
            <form className="reset-form" onSubmit={this.handleSubmit}>
              <div className="input-wrap">
                <PasswordWrapper value={this.state.formData.password}
                                 errorText={this.state.errors.password}
                                 name="password"
                                 key="password"
                                 handleChange={this.handleChange}
                                 placeholder="New Password"
                />
                <PasswordWrapper value={this.state.formData.password_confirmation}
                                 errorText={this.state.errors.password_confirmation}
                                 name="password_confirmation"
                                 key="password_confirmation"
                                 placeholder="Confirm Password"
                                 handleChange={this.handleChange}/>
              </div>
              <div className="button-set">
                <button className="btn blue rounded submit-btn" type="submit">Confirm</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/modules/auth/containers/ResetFormPassword.js